// MARK: - Semantic Keyword → Effect Map
// Ported verbatim from Services/Audio/SoundEffectLibrary.swift (selectSemanticEffect, ~lines 228-686)
// Key insertion order is preserved for deterministic substring-fallback iteration.

export const SEMANTIC_MAP: Record<string, string> = {
  // Vehicle/Transportation Context
  'car': 'car_crash',
  'drive': 'car_crash',
  'driving': 'car_crash',
  'vehicle': 'car_crash',
  'truck': 'car_crash',
  'crash': 'car_crash',
  'accident': 'car_crash',

  // Food/Eating Context
  'food': 'chomp',
  'eat': 'chomp',
  'eating': 'chomp',
  'bite': 'chomp',
  'chew': 'chomp',
  'hungry': 'chomp',
  'meal': 'chomp',
  'dinner': 'ding',
  'cook': 'ding',
  'cooking': 'ding',
  'kitchen': 'ding',
  'microwave': 'ding',

  // Money/Financial Context
  'broke': 'sad_trombone',
  'poor': 'sad_trombone',
  'cheap': 'sad_trombone',
  'cost': 'sad_trombone',
  'pay': 'sad_trombone',
  'job': 'sad_trombone',
  'work': 'sad_trombone',
  'unemployed': 'sad_trombone',

  // Appearance/Looks Context
  'look': 'slide_whistle',
  'looks': 'gasp',
  'face': 'duck_quack',
  'ugly': 'gasp',
  'beautiful': 'applause',
  'pretty': 'applause',
  'handsome': 'applause',
  'outfit': 'duck_quack',
  'clothes': 'duck_quack',
  'style': 'sad_trombone',
  'fashion': 'sad_trombone',

  // Hair Context
  'hair': 'slide_whistle',
  'haircut': 'slide_whistle',
  'bald': 'slide_whistle',
  'hairy': 'slide_whistle',

  // Technology Context
  'phone': 'windows_xp',
  'computer': 'windows_xp',
  'internet': 'windows_xp',
  'tech': 'windows_xp',
  'app': 'windows_xp',
  'website': 'windows_xp',
  'email': 'windows_xp',

  // Weight/Size Context
  'fat': 'thud',
  'big': 'thud',
  'huge': 'thud',
  'massive': 'thud',
  'heavy': 'thud',
  'small': 'pop',
  'tiny': 'pop',
  'little': 'pop',

  // Actions/Movement
  'fall': 'thud',
  'drop': 'thud',
  'run': 'whoosh',
  'slow': 'slide_whistle',
  'move': 'whoosh',
  'splash': 'splash',
  'water': 'splash',
  'swim': 'splash',
  'wet': 'splash',

  // Reactions/Emotions
  'amazing': 'applause',
  'awesome': 'applause',
  'great': 'applause',
  'good': 'applause',
  'wow': 'gasp',
  'omg': 'gasp',
  'shocking': 'gasp',
  'funny': 'rimshot',
  'hilarious': 'rimshot',
  'laugh': 'rimshot',
  'silence': 'crickets',
  'boring': 'crickets',
  'yell': 'dj_airhorn',
  'loud': 'dj_airhorn',
  'scream': 'dj_airhorn',
  'excited': 'dj_airhorn',

  // Negative Outcomes
  'fail': 'sad_trombone',
  'failure': 'sad_trombone',
  'wrong': 'sad_trombone',
  'mistake': 'sad_trombone',
  'bad': 'sad_trombone',
  'terrible': 'sad_trombone',
  'awful': 'sad_trombone',
  'horrible': 'sad_trombone',

  // Comedy/Silly Context
  'weird': 'duck_quack',
  'strange': 'duck_quack',
  'odd': 'duck_quack',
  'ridiculous': 'duck_quack',
  'idiot': 'fart',
  'moron': 'fart',

  // Bell/Notification Context
  'ding': 'bell',
  'call': 'bell',
  'notification': 'bell',

  // Dramatic/Suspense
  'serious': 'dundundunnn',
  'important': 'dundundunnn',
  'announce': 'dundundunnn',

  // Record Scratch - "Wait, what?" moments (more targeted)
  'wait': 'record_scratch',
  'hold': 'record_scratch',
  'actually': 'record_scratch',
  'really': 'record_scratch',
  'seriously': 'record_scratch',
  'honestly': 'record_scratch',
  'literally': 'record_scratch',
  'excuse': 'record_scratch',
  'kidding': 'record_scratch',
  'joking': 'record_scratch',
  'thought': 'record_scratch',
  'assumed': 'record_scratch',
  'supposed': 'record_scratch',
  'expected': 'record_scratch',
  'imagine': 'record_scratch',
  'believe': 'record_scratch',

  // NEW EFFECTS - Reactions (12 additions)
  'realization': 'aha_moment',
  'realize': 'aha_moment',
  'understand': 'aha_moment',
  'figured': 'aha_moment',
  'discovered': 'aha_moment',
  'eureka': 'aha_moment',
  'lightbulb': 'aha_moment',

  'awkward': 'awkward_silence',
  'uncomfortable': 'awkward_silence',
  'cringe': 'awkward_silence',
  'embarrassing': 'awkward_silence',
  'embarrassed': 'awkward_silence',
  'speechless': 'awkward_silence',

  'swallow': 'gulp',
  'nervous': 'gulp',
  'scared': 'gulp',
  'worried': 'gulp',
  'anxious': 'gulp',
  'sweating': 'gulp',

  'no': 'nooo',
  'reject': 'nooo',
  'refuse': 'nooo',
  'denied': 'nooo',
  'rejection': 'nooo',
  'disapprove': 'nooo',

  'solo': 'solo_applause',
  'alone': 'solo_applause',
  'single': 'solo_applause',
  'lonely': 'solo_applause',
  'yourself': 'solo_applause',

  'correct': 'correct_answer',
  'right': 'correct_answer',
  'accurate': 'correct_answer',
  'precise': 'correct_answer',
  'exactly': 'correct_answer',

  'party': 'party_horn',
  'celebrate': 'party_horn',
  'birthday': 'party_horn',
  'festive': 'party_horn',
  'celebration': 'party_horn',

  'whoop': 'whoop_whoop',
  'police': 'whoop_whoop',
  'siren': 'whoop_whoop',
  'trouble': 'whoop_whoop',
  'busted': 'whoop_whoop',

  'jackpot': 'jackpot',
  'winner': 'jackpot',
  'lottery': 'jackpot',
  'lucky': 'jackpot',
  'fortune': 'jackpot',

  'tada': 'tada_new',
  'present': 'tada_new',
  'reveal': 'tada_new',
  'voila': 'tada_new',

  'boxing': 'boxing_bell',
  'fight': 'boxing_bell',
  'round': 'boxing_bell',
  'knockout': 'boxing_bell',
  'fighter': 'boxing_bell',

  // NEW EFFECTS - Objects (17 additions)
  'dog': 'bark_dog',
  'puppy': 'bark_dog',
  'bark': 'bark_dog',
  'woof': 'bark_dog',
  'canine': 'bark_dog',

  'bone': 'bone_crack',
  'crack': 'bone_crack',
  'snap': 'bone_crack',
  'break': 'bone_crack',
  'fracture': 'bone_crack',

  'bonk': 'bonk',
  'bump': 'bonk',
  'head': 'bonk',
  'dumb': 'bonk',
  'stupid': 'bonk',

  'gun': 'gun_cock',
  'shoot': 'gun_cock',
  'weapon': 'gun_cock',
  'loaded': 'gun_cock',
  'armed': 'gun_cock',

  'coin': 'coin_collect',
  'coins': 'coin_collect',
  'collect': 'coin_collect',
  'treasure': 'coin_collect',
  'gold': 'coin_collect',

  'donk': 'donk',
  'hollow': 'donk',
  'empty': 'donk',
  'dense': 'donk',

  'munch': 'munch',
  'snack': 'munch',
  'crunch': 'munch',
  'chips': 'munch',
  'crunchy': 'munch',

  'oof': 'oof',
  'ouch': 'oof',
  'hurt': 'oof',
  'pain': 'oof',
  'damage': 'oof',

  'punch': 'punch_hit',
  'hit': 'punch_hit',
  'strike': 'punch_hit',
  'beat': 'punch_hit',
  'smack': 'punch_hit',

  'duck': 'quack_duck',
  'quack': 'quack_duck',
  'waddle': 'quack_duck',
  'pond': 'quack_duck',

  'kiss': 'smooch',
  'smooch': 'smooch',
  'lips': 'smooch',
  'romantic': 'smooch',
  'love': 'smooch',

  'whip': 'whip_smack',
  'whipped': 'whip_smack',
  'controlled': 'whip_smack',
  'dominated': 'whip_smack',

  'cat': 'meow_cat',
  'kitten': 'meow_cat',
  'meow': 'meow_cat',
  'feline': 'meow_cat',
  'kitty': 'meow_cat',

  'bell': 'ding_bell',
  'chime': 'ding_bell',
  'ring': 'ding_bell',

  'money': 'kaching',
  'cash': 'kaching',
  'rich': 'kaching',
  'wealth': 'kaching',
  'expensive': 'kaching',

  'pop': 'pop_sound',
  'bubble': 'pop_sound',
  'burst': 'pop_sound',

  'jump': 'game_jump',
  'hop': 'game_jump',
  'leap': 'game_jump',
  'mario': 'game_jump',
  'platform': 'game_jump',

  // NEW EFFECTS - Comedy (14 additions)
  'anime': 'anime_wow',
  'japanese': 'anime_wow',
  'manga': 'anime_wow',
  'otaku': 'anime_wow',
  'kawaii': 'anime_wow',

  'bababoey': 'bababoey',
  'howard': 'bababoey',
  'stern': 'bababoey',

  'rehehe': 'rehehe',
  'giggle': 'rehehe',
  'snicker': 'rehehe',
  'chuckle': 'rehehe',

  'rizz': 'rizz_sound',
  'charm': 'rizz_sound',
  'smooth': 'rizz_sound',
  'flirt': 'rizz_sound',

  'yeet': 'yeet',
  'throw': 'yeet',
  'toss': 'yeet',
  'launch': 'yeet',
  'send': 'yeet',

  'akh': 'akh',
  'spit': 'akh',
  'disgusting': 'akh',
  'gross': 'akh',

  'huh': 'huh',
  'confused': 'huh',
  'what': 'huh',
  'confusion': 'huh',

  'do': 'do_it',
  'motivation': 'do_it',
  'shia': 'do_it',
  'just': 'do_it',

  'mongolian': 'mongolian_throat',
  'throat': 'mongolian_throat',
  'singing': 'mongolian_throat',
  'unique': 'mongolian_throat',

  'stank': 'stank',
  'stink': 'stank',
  'smell': 'stank',
  'odor': 'stank',
  'smelly': 'stank',

  'rimshot': 'ba_dum_tss',
  'punchline': 'ba_dum_tss',
  'joke': 'ba_dum_tss',
  'comedy': 'ba_dum_tss',

  'honk': 'cartoon_honk',
  'beep': 'cartoon_honk',
  'cartoon': 'cartoon_honk',

  'clown': 'clown_horn',
  'circus': 'clown_horn',
  'goofy': 'clown_horn',
  'silly': 'clown_horn',

  'mcdonalds': 'mcbeep',
  'burger': 'mcbeep',
  'fries': 'mcbeep',
  'fastfood': 'mcbeep',

  // NEW EFFECTS - Transitions (15 additions)
  'alert': 'alert',
  'warning': 'alert',
  'attention': 'alert',
  'notice': 'alert',

  'gong': 'gong',
  'meditation': 'gong',
  'zen': 'gong',
  'peace': 'gong',

  'emergency': 'siren_burst',
  'urgent': 'siren_burst',
  'danger': 'siren_burst',

  'time': 'tick_tock',
  'clock': 'tick_tock',
  'ticking': 'tick_tock',
  'deadline': 'tick_tock',

  'undertaker': 'undertaker_bell',
  'death': 'undertaker_bell',
  'funeral': 'undertaker_bell',
  'grave': 'undertaker_bell',
  'dead': 'undertaker_bell',

  'core': 'core_whoosh',
  'center': 'core_whoosh',
  'middle': 'core_whoosh',

  'dream': 'dream_descend',
  'sleep': 'dream_descend',
  'nightmare': 'dream_descend',
  'dreaming': 'dream_descend',

  'dramatic': 'dramatic_strings',
  'intense': 'dramatic_strings',
  'suspense': 'dramatic_strings',
  'tension': 'dramatic_strings',

  'heaven': 'heavenly_dream',
  'angel': 'heavenly_dream',
  'divine': 'heavenly_dream',
  'blessed': 'heavenly_dream',

  'power': 'power_up',
  'level': 'power_up',
  'upgrade': 'power_up',
  'boost': 'power_up',

  'psycho': 'psycho_strings',
  'crazy': 'psycho_strings',
  'insane': 'psycho_strings',
  'mad': 'psycho_strings',

  'sword': 'sching',
  'blade': 'sching',
  'slash': 'sching',
  'cut': 'sching',

  'swoosh': 'swish',
  'quick': 'swish',

  'twinkle': 'twinkle',
  'sparkle': 'twinkle',
  'shine': 'twinkle',
  'glitter': 'twinkle',

  'pluck': 'pluck',
  'string': 'pluck',
  'guitar': 'pluck',
  'banjo': 'pluck',
};
